<template>
  <div id="contenedor-reportar-partida-editar-reportes-fisiccos">
    <v-alert
      type="info"
      text>
      {{ partida.concepto }}
    </v-alert>
    <v-form
      v-model="formularioValido"
      ref="reportarPartida">
      <v-row>
        <custom-text-field
          v-model.number="reportarPartida.avanceFisico"
          cols="12"
          md="4"
          label="Avance"
          prefix="%"
          @keyup="calcularAvancePonderado"
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <custom-text-field
          v-model.number="partida.ponderadoPartida"
          cols="12"
          md="4"
          label="Ponderado"
          prefix="%"
          readonly
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <custom-text-field
          v-model.number="reportarPartida.avancePonderado"
          cols="12"
          md="4"
          label="Av. Ponderado"
          prefix="%"
          readonly
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <custom-text-area
          v-model="reportarPartida.comentario"
          label="Comentarios (opcional)"
          rows="3"
          auto-grow>
        </custom-text-area>
      </v-row>
      <div id="contenedor-album-fotografico">
        <v-row>
          <template
            v-for="(imagen, index) in imagenes">
            <template>
              <v-col
                cols="auto"
                class="pa-1"
                :key="`img-${index}`">
                <v-img
                  :src="imagen"
                  height="180"
                  width="180"
                  contain
                  class="blue-grey darken-4">
                  <div class="contenedor-imagenes-remover-imagen">
                    <v-btn
                      small
                      icon
                      dark
                      @click="removerImagen(index)">
                      <v-icon>
                        mdi-close-circle
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-col>
            </template>
          </template>
          <v-col
            cols="auto">
            <div
              class="contenedor-imagenes-agregar"
              @click="$refs.seleccionarAnexo.click()">
              <v-img
                src="@/assets/add-img-img.png"
                contain
                height="100"
                width="100">
              </v-img>
            </div>
          </v-col>
        </v-row>
      </div>
      <input
        type="file"
        ref="seleccionarAnexo"
        id="anexo"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        capture="camera"
        multiple
        @change="preCargarImagenes">
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';

export default {
  name: 'ReportarPartidaEditarReportesFisicos',
  props: {
    partida: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomTextArea,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      imagenes: [],
      reportarPartida: {
        idPartida: this.partida.id,
        avanceFisico: 0,
        ponderadoPartida: 0,
        avancePonderado: 0,
        comentario: '',
        imagenes: [],
      },
    };
  },
  mounted() {
    const este = this;
    este.reportarPartida.avanceFisico = este.partida.reportado.avanceFisico;
    este.reportarPartida.ponderadoPartida = este.partida.reportado.ponderadoPartida;
    este.reportarPartida.avancePonderado = este.partida.reportado.avancePonderado;
    este.reportarPartida.comentario = este.partida.reportado.comentario;
    este.reportarPartida.imagenes = este.partida.reportado.imagenes;
    este.crearUrlDeLasImagenesSeleccionadas();
  },
  methods: {
    guardar() {
      this.$emit('guardar', this.reportarPartida);
    },
    calcularAvancePonderado() {
      const { ponderadoPartida } = this.partida;
      const { avanceFisico } = this.reportarPartida;
      this.reportarPartida.avancePonderado = this.$numberRoundDigits((
        ponderadoPartida
        * (avanceFisico / 100)
      ), 2);
    },
    preCargarImagenes() {
      const { imagenes } = this.reportarPartida;
      // get las fotos
      const fileInput = document.getElementById('anexo');
      imagenes.push(...fileInput.files);

      for (let i = 0; i < fileInput.files.length; i += 1) {
        const url = URL.createObjectURL(fileInput.files[i]);
        this.imagenes.push(url);
      }
    },
    crearUrlDeLasImagenesSeleccionadas() {
      const { imagenes } = this.reportarPartida;
      for (let i = 0; i < imagenes.length; i += 1) {
        if (typeof (imagenes[i]) === 'string') {
          const url = `${this.$urlFileServer}/${imagenes[i]}`;
          this.imagenes.push(url);
        } else {
          const url = URL.createObjectURL(imagenes[i]);
          this.imagenes.push(url);
        }
      }
    },
    removerImagen(index) {
      this.imagenes.splice(index, 1);
      this.reportarPartida.imagenes.splice(index, 1);
    },
    limpiarFormulario() {
      this.$refs.reportarPartida.reset();
      this.imagenes = [];
      this.reportarPartida.imagenes = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  watch: {
    partida: {
      handler() {
        this.reportarPartida.ponderadoPartida = this.partida.ponderadoPartida || 0;
        this.reportarPartida.avanceFisico = this.partida.reportado.avanceFisico;
        this.reportarPartida.avancePonderado = this.partida.reportado.avancePonderado;
        this.reportarPartida.comentario = this.partida.reportado.comentario;
        this.reportarPartida.imagenes = this.partida.reportado.imagenes;
        this.crearUrlDeLasImagenesSeleccionadas();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-vista-previa {
  position: relative;
}
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagenes-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagenes-agregar:hover {
  border: 2px solid #ccc;
}
</style>
